import moment from 'moment'

export const LIVE_SYNC_INTERVAL_MS = 45 * 1000
export const HIDDEN_RESYNC_THRESHOLD_MS = 30 * 1000
export const SYNC_CREATED_AT_FORMAT = 'YYYY-MM-DD HH:mm:ss'

export function buildSyncMarker (items = []) {
  let latest = null

  for (const item of items) {
    if (item?.id && (!latest || item.id > latest.id)) {
      latest = item
    }
  }

  if (!latest) {
    return null
  }

  return {
    id: latest.id,
    createdAt: latest.created_at ? moment.utc(latest.created_at).format(SYNC_CREATED_AT_FORMAT) : null
  }
}

export function syncItemKey (item, threaded) {
  return threaded ? item.contact_id : item.id
}

export function mergeSyncedItems (current, incoming, { threaded = true } = {}) {
  const items = [...current]
  const added = []
  let updated = 0

  for (const row of incoming) {
    if (!row?.contact?.id || row.hidden) {
      continue
    }

    const key = syncItemKey(row, threaded)
    const addedIndex = added.findIndex(item => syncItemKey(item, threaded) === key)

    if (addedIndex !== -1) {
      if (!threaded || row.id >= added[addedIndex].id) {
        added.splice(addedIndex, 1, row)
      }
      continue
    }

    const index = items.findIndex(item => syncItemKey(item, threaded) === key)

    if (index === -1) {
      added.push(row)
      continue
    }

    const existing = items[index]

    if (threaded && row.id < existing.id) {
      items.splice(index, 1, { ...existing, inbox_unread_count: row.inbox_unread_count })
    } else {
      items.splice(index, 1, row)
    }

    updated++
  }

  return { items, added, updated }
}

export function repointMergedContact (items, fromId, toId, { threaded = true } = {}) {
  const survivorHasRow = threaded && items.some(item => item.contact_id === toId)

  return items
    .filter(item => !(survivorHasRow && item.contact_id === fromId))
    .map(item => item.contact_id !== fromId
      ? item
      : { ...item, contact_id: toId, contact: { ...(item.contact || {}), id: toId } })
}

export function shouldResyncAfterHidden (hiddenAt, now = Date.now()) {
  return Boolean(hiddenAt) && now - hiddenAt > HIDDEN_RESYNC_THRESHOLD_MS
}
